import { Box, Card, Typography } from "@mui/material";
import React, { useState } from "react";
import ProjectsTable, { ProjectsTableContextType } from "./ProjectsTable";

export default function Projects() {
  const [tableContext, setTableContext] =
    useState<ProjectsTableContextType>("usa-spending");

  return (
    <Box
      sx={{
        p: 2,
        textAlign: "start",
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography variant={"body2"} sx={{ mb: 3 }}>
        {tableContext === "usa-spending"
          ? "A database of State Department projects that allows you to quickly sort State Department project activity by closing date for your target countries, competitors, and technical sectors. This tool is designed to deliver rapid, landscape snapshots of State Department projects, but is not meant to be comprehensive of every State Department project. It is based on State Department project data from USA Spending."
          : "Search current and past State Department projects by country, sector, and closing date. This page allows you to quickly sort State Department project activity by closing date for your target countries, competitors, and technical sectors. This tool is designed to deliver rapid, landscape snapshots of State Department projects, and may not have every State Department project."}
      </Typography>
      <ProjectsTable
        containerSx={{
          height: "100%",
          position: "initial",
          borderRadius: "0 0 4px 4px !important",
        }}
        externalSetTableContext={setTableContext}
        useFragmentHeader={false}
        allowViewTypeSwitch
        showActions
        loadDataImmediately={false}
      />
    </Box>
  );
}
